import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

export type FinderLinkParams =
  /**
   * Finder Page in Integrations
   * /finder
   */
  {
    page: 'finder';
    accountId?: string;
  };

export const getLinkForFinder = (params: FinderLinkParams): ValidHref => {
  const pathname: ValidHref = `/finder`;
  const searchParams: { a?: string } = {};

  // ... ?a=:accountId
  if ('accountId' in params && params.accountId) {
    searchParams.a = toCondensedUUID(params.accountId);
  }

  return createUrl({
    pathname,
    searchParams,
  });
};

export const isFinderPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  if (parts[1] === 'finder') {
    return true;
  }
  return false;
};
